module.exports = __webpack_public_path__ + "static/media/icon-emergency.c3c37cd3.svg";